export default [
  'PLATFORM',
  'JOBS',
  'INTERVIEWS',
  'SURVEYS',
  'REVIEWS',
  'CAREER_PATHS',
  'PEOPLE',
  'PIPELINES'
].reduce((acc, cv) => ({ ...acc, [cv]: cv }), {});
